import React from "react";
import { useFormatter } from "./../../../util/formatter";

const width = 150;
const [formatNumber] = useFormatter();

const formatDiff = (value) => {
	if (value !== "-") {
		if (value > 0) return <strong style={{ color: "green" }}>{value}</strong>;
		else return <strong style={{ color: "red" }}>{value}</strong>;
	} else return value;
};

const formatZero = (val) => {
	return val <= 0 ? "-" : val;
};

const isValEmpty = (val) => val === null || val === undefined || val === "";
const formatNummber = (val) => isValEmpty(val) ? "-" : Number(parseFloat(val).toFixed(2));	

export const OMCOLS = [
	{ title: "Client", field: "company", width },
	{
		title: "Site name",
		field: "siteName",
		grouping: false,
		width,
	},
	{
		title: "SF ID",
		field: "SF_project_id",
		grouping: false,
		render: (s) => isValEmpty(s.SF_project_id) ? "-" : s.SF_project_id,
		width,
	},
	/* {
		title: "Capacity (kWh)",
		field: "capacity",
		grouping: false,
		width,
	},
	{
		title: "Status",
		field: "siteStatus",
		grouping: false,
		width,
	},
	{
		title: "COD",
		field: "COD",
		grouping: false,
		width,
	},
	{
		title: "Entity",
		field: "solar_entity",
		grouping: false,
		width,
	}, */
	{
		title: "Month of accumulated",
		field: "accumMonths",
		grouping: false,
		type: "numeric",
		width,
		render: (s) => formatNummber(s.accumMonths),
		filtering: false,
	},
	{
		title: "Year of accumulated",
		field: "accumYears",
		grouping: false,
		type: "numeric",
		width,
		render: (s) => formatNummber(s.accumYears),
		filtering: false,
	},
	{
		title: "Actual solar prod (kWh)",
		field: "actualProd",
		grouping: false,
		type: "numeric",
		width,
		render: (s) => formatNummber(s.actualProd),
		filtering: false,
	},
	{
		title: "Expected prod BP initial (kWh)",
		field: "expProd",
		grouping: false,
		width,
		filtering: false,
		render: (s) => formatNummber(s.expProd),
	},
	{
		title: "Actual vs Expected BP initial prod",
		field: "actProdVsExpProd",
		grouping: false,
		width,
		render: (s) => formatNummber(s.actProdVsExpProd),
		filtering: false,
	},
	{
		title: "% Diff",
		field: "diffProd",
		grouping: false,
		width,
		render: (s) => formatNummber(s.diffProd),
		filtering: false,
	},
	{
		title: "Theoritical energy (kWh)",
		field: "theoEnergy", // NRG is an abbreviation of energy
		grouping: false,
		render: (s) => formatNummber(s.theoEnergy),
		width,
		filtering: false,
	},
	{
		title: "Site scheme clasified",
		field: "siteScheme",
		grouping: false,
		width,
		lookup: { 1: "Unused", 2: "EVN Curltailment" },
	},
	/* {
		title: "Type of TOP",
		field: "isTOP",
		grouping: false,
		width,
		filtering: false,
	}, */
	{
		title: "Unused",
		field: "siteUnused",
		grouping: false,
		width,
		render: (s) => formatNummber(s.siteUnused),
		filtering: false,
	},
	{
		title: "EVN curtailment",
		field: "evnCurtailment",
		grouping: false,
		width,
		render: (s) => formatNummber(s.evnCurtailment),
		filtering: false,
	},
	{
		title: "LGP",
		field: "lgp",
		grouping: false,
		width,
		render: (s) => formatNummber(s.lgp),
		filtering: false,
	},
	{
		title: "% Actual LGP",
		field: "actualLGP_per",
		grouping: false,
		width,
		render: (s) => formatNummber(s.actualLGP_per),
		filtering: false,
	},
	/* {
		title: "Target Unused",
		field: "unusedThisMonth",
		grouping: false,
		width,
	}, */
	{
		title: "Expected monthly unused (kWh)",
		field: "expMonUn",
		grouping: false,
		width,
		render: (s) => formatNummber(s.expMonUn),
		filtering: false,
	},
	{
		title: "% Expected monthly unused",
		field: "expMonUn_per",
		grouping: false,
		width,
		render: (s) => formatNummber(s.expMonUn_per),
		filtering: false,
	},
	/* {
		title: "Actual vs Expected LGP",
		field: "vsProdLGP",
		grouping: false,
		width,
		render: (site) => formatZero(site.vsProdLGP),
	}, */
	{
		title: "Actual production including LGP (kWh)",
		field: "actualProdLGP",
		grouping: false,
		render: (s) => formatNummber(s.actualProdLGP),
		width,
		filtering: false,
	},
	{
		title: "(Actual + LGP) vs Expected BP initial prod (kWh)",
		field: "actualProdLGPvsExpProd",
		grouping: false,
		render: (s) => formatNummber(s.actualProdLGPvsExpProd),
		width,
		filtering: false,
	},
	{
		title: "% Diff",
		field: "actualProdLGPvsExpProd_per",
		grouping: false,
		width,
		render: (s) => formatNummber(s.actualProdLGPvsExpProd_per),
		filtering: false,
	},
	/* {
		title: "Expected BP inital prod vs Expected unused (KWh)",
		field: "expProdvsExpUn",
		grouping: false,
		width,
	},
	{
		title: "Actual Prod Diff (Expected BP inital prod - Expected unused) (%)",
		field: "actProdDiffExp",
		grouping: false,
		width,
	},
	{
		title: "Expected BP inital prod - Expected unused (KWh)  - Delta Unused",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected BP initial prod + Actual Unused (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	}, */
	{
		title: "Actual irradiation (KWh/m2)",
		field: "actual_irradiation",
		grouping: false,
		render: (s) => formatNummber(s.actual_irradiation),
		width,
		filtering: false,
	},
	{
		title: "Expected horizontal irradiation (KWh/m2)",
		field: "expIrr",
		grouping: false,
		render: (s) => formatNummber(s.expIrr),
		width,
		filtering: false,
	},
	/* {
		title: "Var irradaition",
		field: "diffProdLGP",
		grouping: false,
		width,
	}, */
	{
		title: "Var irradiance (%)",
		field: "diffIrr",
		grouping: false,
		width,
		render: (s) => formatNummber(s.diffIrr),
		filtering: false,
	},
	{
		title: "Module temp",
		field: "moduleTemp",
		grouping: false,
		width,
		render: (s) => formatNummber(s.moduleTemp),
		filtering: false,
	},
	{
		title: "PR expected (BP initial)",
		field: "expPR",
		grouping: false,
		width,
		render: (s) => formatNummber(s.expPR),
		filtering: false,
	},
	{
		title: "PR actual (%)",
		field: "brutPR",
		grouping: false,
		render: (s) => formatNummber(s.brutPR),
		width,
		filtering: false,
	},
	/* {
		title: "PR temp-corrected",
		field: "diffProdLGP",
		grouping: false,
		width,
	}, */
	/* {
		title: "PR actual vs Expected BP initial (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
		filtering: false 
	},
	{
		title: "PR theoritical (%)",
		field: "theoreticalPR",
		grouping: false,
		width,
		filtering: false 
	}, */
	/* {
		title: "PR theorical temp corr (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	}, */
	/* {
		title: "Performance loss (kWh)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected PR as-build PVSyst",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Diff PR as-build (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "E_cal",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "EPI + EPI unused",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Curtailment loss (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected unused (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Actual - Expected unused (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Performance index (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	}, 
	{
		title: "Losses [GA]",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Losses [TPA]",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Non-prodcution loss [GA & TPA]",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Losses [TA]",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "TA losses (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Energy Th",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Technical availability (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "TA for prorate",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Grid Availaibility (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "GA for prorate",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Client availaibility [CA]",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "CA for prorate",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected energy [PVSyst as-build]",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected BP initial yield (KWh)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Over size",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected monthy unused (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "PPA unused (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected monthly unused",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "TA",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected TA (kWh)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "GA",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected GA (kWh)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected BP final (KWh)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Irr [actual] x Energy prod",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Irr [expected] x Energy prod",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Seasonality (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Energy ratio (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected tilt irradiance (KWh/m2)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Irradiance from expected (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected PR BP initial base (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected PR BP exclude TA GA BASE (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Expected PR corr (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "Actual PR + PR losses (%)",
		field: "diffProdLGP",
		grouping: false,
		width,
	},
	{
		title: "",
		field: "diffProdLGP",
		grouping: false,
		width,
	},*/
	{
		title: "TA x GA (%)",
		field: "taGA",
		grouping: false,
		width,
		render: (s) => formatNummber(s.taGA),
		filtering: false,
	},
	{
		title: "Technical Availability (%)",
		field: "TA",
		grouping: false,
		width,
		render: (s) => formatNummber(s.TA),
		filtering: false,
	},
	{
		title: "TA for prorate (TA x Exp Prod)",
		field: "TAprorate",
		grouping: false,
		width,
		render: (s) => formatNummber(s.TAprorate),
		filtering: false,
	},
	{
		title: "Grid Availability (%)",
		field: "GA",
		grouping: false,
		width,
		render: (s) => formatNummber(s.GA),
		filtering: false,
	},
	{
		title: "GA for prorate (GA x Exp Prod)",
		field: "GAprorate",
		grouping: false,
		width,
		render: (s) => formatNummber(s.GAprorate),
		filtering: false,
	},
	/* {
		title: "Client Availability (%)",
		field: "CA",
		grouping: false,
		width,
		filtering: false,
	},
	{
		title: "CA for prorate (CA x Exp Prod)",
		field: "CAprorate",
		grouping: false,
		width,
		filtering: false,
	}, */
	{
		title: "Performance index", // var irr - var prod
		field: "perInx",
		grouping: false,
		width,
		render: (s) => formatNummber(s.perInx),
		filtering: false,
	},
	{
		title: "Performance index including LGP", // var irr - var prod
		field: "perInxLGP",
		grouping: false,
		width,
		render: (s) => formatNummber(s.perInxLGP),
		filtering: false,
	},
	{
		title: "TA x GA Loss (%)",
		field: "taGALoss",
		grouping: false,
		width,
		render: (s) => formatNummber(s.taGALoss),
		filtering: false,
	},
];
